<ng-container *transloco="let t">
  @if (showNavBar()) {
    @if (isMobile()) {
      <div id="native-servicing-tabs" class="w-full bg-ld-neutral-100 py-2 overflow-x-auto">
        <div class="flex items-center gap-3 w-max pl-4 pr-4">
          <button
            id="native-tab-payments"
            type="button"
            class="flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold font-dm whitespace-nowrap transition-colors border cursor-pointer"
            [class]="
              isActiveTab('payments') ? 'bg-black text-white border-black' : 'bg-white text-black border-ld-neutral-300'
            "
            [disabled]="!hasLoan()"
            (click)="hasLoan() ? onPayments() : null"
          >
            <mat-icon class="text-[18px]! w-[18px]! h-[18px]!">account_balance_wallet</mat-icon>
            <span>{{ t('commonPayments') }}</span>
          </button>
          <button
            id="native-tab-statements"
            type="button"
            class="flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold font-dm whitespace-nowrap transition-colors border cursor-pointer"
            [class]="
              isActiveTab('statements')
                ? 'bg-black text-white border-black'
                : 'bg-white text-black border-ld-neutral-300'
            "
            [disabled]="!hasLoan()"
            (click)="hasLoan() ? onStatementsDocuments() : null"
          >
            <mat-icon class="text-[18px]! w-[18px]! h-[18px]!">description</mat-icon>
            <span>{{ t('commonStatementsDocuments') }}</span>
          </button>
          <button
            id="native-tab-settings"
            type="button"
            class="flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold font-dm whitespace-nowrap transition-colors border cursor-pointer"
            [class]="
              isActiveTab('settings') ? 'bg-black text-white border-black' : 'bg-white text-black border-ld-neutral-300'
            "
            [disabled]="!hasLoan()"
            (click)="hasLoan() ? nativeMenuService.open('settings') : null"
          >
            <mat-icon class="text-[18px]! w-[18px]! h-[18px]!">settings</mat-icon>
            <span>{{ t('commonSettings') }}</span>
          </button>
        </div>
      </div>
    } @else {
      <div id="servicing-header" class="w-full relative z-10">
        <div id="servicing-nav-bar" class="w-full h-14 flex items-center justify-center bg-ld-neutral-700">
          <div class="max-w-[1440px] w-full h-full flex items-center gap-4 px-4 sm:px-8">
            @if (hasLoan() && getEffectiveLoanAddress()) {
              @if (getAccounts().length > 1) {
                <button
                  id="nav-loan-selector"
                  type="button"
                  class="flex items-center gap-2 sm:gap-4 py-3 max-w-[calc(100vw-5rem)] sm:max-w-[450px] rounded-3xl shadow-card hover:opacity-90 transition-opacity cursor-pointer min-w-0"
                  [matMenuTriggerFor]="loanMenu"
                >
                  <span
                    class="font-dm font-semibold text-xl uppercase tracking-[0.4px] leading-8 shrink-0"
                    [class]="getLoanTypeHeaderColorClass()"
                  >
                    {{ getLoanTypeLabel() }}
                  </span>
                  <span class="flex items-center gap-2 font-dm tracking-[0.16px] min-w-0 overflow-hidden">
                    <span class="font-bold text-[13px] text-white leading-7 shrink-0">
                      Loan No. -{{ getSelectedAccountLast4() }}
                    </span>
                    <span class="text-base text-ld-neutral-200 leading-7 shrink-0">|</span>
                    <span class="text-xs text-ld-neutral-100 leading-7 truncate">
                      {{ getEffectiveLoanAddress() }}
                    </span>
                  </span>
                  <svg
                    class="w-6 h-6 shrink-0 text-white"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>

                <mat-menu #loanMenu="matMenu" class="loan-selector-menu" xPosition="after">
                  @for (account of getAccounts(); track account.id) {
                    <button
                      mat-menu-item
                      [id]="'loan-selector-item-' + account.id"
                      [class.bg-ld-primary-50]="getEffectiveSelectedAccountId() === account.id"
                      (click)="onLoanSelect(account.id)"
                    >
                      <div class="loan-menu-item-content">
                        <span class="loan-menu-checkmark">
                          @if (getEffectiveSelectedAccountId() === account.id) {
                            <mat-icon class="w-5! h-5! text-[20px]! text-ld-primary" aria-hidden="true">check</mat-icon>
                          }
                        </span>
                        <span class="loan-menu-info">
                          <span
                            class="font-dm font-semibold text-base tracking-[0.4px]"
                            [class]="getLoanTypeColorClassFor(account.type)"
                          >
                            {{ getLoanTypeLabelFor(account.type) }}
                          </span>
                          <span class="font-dm text-sm text-ld-neutral-500 tracking-[0.16px]">
                            <span class="font-bold">Loan No. -{{ account.accountNumberLast4 }}</span>
                            <span class="font-medium">&nbsp;| {{ account.address }}</span>
                          </span>
                        </span>
                      </div>
                    </button>
                  }
                </mat-menu>
              } @else {
                <div
                  id="nav-loan-display"
                  class="flex items-center gap-4 py-3 max-w-[450px] rounded-3xl shadow-card min-w-0 overflow-hidden"
                >
                  <span
                    class="font-dm font-semibold text-xl uppercase tracking-[0.4px] leading-8 shrink-0"
                    [class]="getLoanTypeHeaderColorClass()"
                  >
                    {{ getLoanTypeLabel() }}
                  </span>
                  <span class="flex items-center gap-2 font-dm tracking-[0.16px] min-w-0">
                    <span class="font-bold text-[13px] text-white leading-7 shrink-0">
                      Loan No. -{{ getSelectedAccountLast4() }}
                    </span>
                    <span class="text-base text-ld-neutral-200 leading-7 shrink-0">|</span>
                    <span class="text-xs text-ld-neutral-100 leading-7 truncate">
                      {{ getEffectiveLoanAddress() }}
                    </span>
                  </span>
                </div>
              }
            }

            <nav id="servicing-nav-tabs" class="hidden xl:flex items-center gap-2 ml-auto h-full">
              <button
                id="nav-tab-payments"
                type="button"
                class="flex items-center gap-2 h-full px-2 py-6 text-base font-medium tracking-[0.32px] border-b-4 transition-colors cursor-pointer bg-transparent border-x-0 border-t-0 disabled:opacity-50 disabled:cursor-not-allowed"
                [class]="
                  isActiveTab('payments')
                    ? 'text-ld-lime border-ld-lime font-semibold'
                    : 'text-white border-transparent hover:text-ld-lime'
                "
                [disabled]="!hasLoan()"
                (click)="hasLoan() ? onPayments() : null"
              >
                <svg
                  class="w-6 h-6 shrink-0"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M15 7.5C15 7.03976 14.6269 6.66667 14.1667 6.66667H5.83333C5.3731 6.66667 5 7.03976 5 7.5V12.5C5 12.9602 5.3731 13.3333 5.83333 13.3333H14.1667C14.6269 13.3333 15 12.9602 15 12.5V7.5ZM10.8333 10C10.8333 9.53976 10.4602 9.16667 10 9.16667C9.53976 9.16667 9.16667 9.53976 9.16667 10C9.16667 10.4602 9.53976 10.8333 10 10.8333C10.4602 10.8333 10.8333 10.4602 10.8333 10ZM12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10ZM11.6667 4.16667C11.6667 3.70643 11.2936 3.33333 10.8333 3.33333H2.5C2.03976 3.33333 1.66667 3.70643 1.66667 4.16667V9.16667C1.66667 9.6269 2.03976 10 2.5 10H3.33333V7.5C3.33333 6.11929 4.45262 5 5.83333 5H11.6667V4.16667ZM13.3333 5H14.1667C15.5474 5 16.6667 6.11929 16.6667 7.5V12.5C16.6667 13.8807 15.5474 15 14.1667 15H5.83333C4.45262 15 3.33333 13.8807 3.33333 12.5V11.6667H2.5C1.11929 11.6667 0 10.5474 0 9.16667V4.16667C0 2.78595 1.11929 1.66667 2.5 1.66667H10.8333C12.214 1.66667 13.3333 2.78595 13.3333 4.16667V5Z"
                    fill="currentColor"
                  />
                </svg>
                <span>{{ t('commonPayments') }}</span>
              </button>

              <button
                id="nav-tab-statements"
                type="button"
                class="flex items-center gap-2 h-full px-2 py-6 text-base font-medium tracking-[0.32px] border-b-4 transition-colors cursor-pointer bg-transparent border-x-0 border-t-0 disabled:opacity-50 disabled:cursor-not-allowed"
                [class]="
                  isActiveTab('statements')
                    ? 'text-ld-lime border-ld-lime font-semibold'
                    : 'text-white border-transparent hover:text-ld-lime'
                "
                [disabled]="!hasLoan()"
                (click)="hasLoan() ? onStatementsDocuments() : null"
              >
                <svg
                  class="w-6 h-6 shrink-0"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M3.33398 15.8346V4.16797C3.33398 2.78726 4.45327 1.66797 5.83398 1.66797H10.4889C10.9309 1.668 11.3548 1.84372 11.6673 2.15625L16.179 6.66797C16.4916 6.9805 16.6673 7.40437 16.6673 7.84635V15.8346C16.6673 17.2153 15.548 18.3346 14.1673 18.3346H5.83398C4.45327 18.3346 3.33398 17.2153 3.33398 15.8346ZM12.5007 12.5013C12.9609 12.5013 13.334 12.8744 13.334 13.3346C13.334 13.7949 12.9609 14.168 12.5007 14.168H7.50065C7.04041 14.168 6.66732 13.7949 6.66732 13.3346C6.66732 12.8744 7.04041 12.5013 7.50065 12.5013H12.5007ZM12.5007 9.16797C12.9609 9.16797 13.334 9.54106 13.334 10.0013C13.334 10.4615 12.9609 10.8346 12.5007 10.8346H7.50065C7.04041 10.8346 6.66732 10.4615 6.66732 10.0013C6.66732 9.54106 7.04041 9.16797 7.50065 9.16797H12.5007ZM5.00065 15.8346C5.00065 16.2949 5.37375 16.668 5.83398 16.668H14.1673C14.6276 16.668 15.0007 16.2949 15.0007 15.8346V7.84635L10.4889 3.33464H5.83398C5.37375 3.33464 5.00065 3.70773 5.00065 4.16797V15.8346Z"
                    fill="currentColor"
                  />
                </svg>
                <span>{{ t('commonStatementsDocuments') }}</span>
              </button>

              <button
                id="nav-tab-settings"
                type="button"
                class="flex items-center gap-2 h-full px-2 py-6 text-base font-medium tracking-[0.32px] border-b-4 transition-colors cursor-pointer bg-transparent border-x-0 border-t-0 disabled:opacity-50 disabled:cursor-not-allowed"
                [class]="
                  isActiveTab('settings')
                    ? 'text-ld-lime border-ld-lime font-semibold'
                    : 'text-white border-transparent hover:text-ld-lime'
                "
                [matMenuTriggerFor]="settingsMenu"
                [disabled]="!hasLoan()"
              >
                <svg
                  class="w-6 h-6 shrink-0"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M7.79321 3.40226C8.35478 1.08987 11.6441 1.08987 12.2056 3.40226C12.302 3.7993 12.7568 3.98829 13.1057 3.77579C15.138 2.53749 17.4633 4.8628 16.225 6.89509C16.0125 7.24402 16.2015 7.69877 16.5985 7.79516C18.9109 8.35673 18.9109 11.646 16.5985 12.2076C16.2015 12.304 16.0125 12.7587 16.225 13.1077C17.4633 15.14 15.138 17.4653 13.1057 16.227C12.7568 16.0145 12.302 16.2035 12.2056 16.6005C11.6441 18.9129 8.35478 18.9129 7.79321 16.6005C7.69682 16.2035 7.24207 16.0145 6.89314 16.227C4.86085 17.4653 2.53554 15.14 3.77384 13.1077C3.98634 12.7587 3.79734 12.304 3.4003 12.2076C1.08792 11.646 1.08792 8.35673 3.4003 7.79516C3.79734 7.69877 3.98634 7.24403 3.77384 6.89509C2.53554 4.8628 4.86085 2.53749 6.89314 3.77579C7.24207 3.98829 7.69682 3.7993 7.79321 3.40226ZM10.5854 3.79614C10.4361 3.18144 9.56271 3.18144 9.41349 3.79614C9.05065 5.28989 7.33838 5.99819 6.02563 5.19832C5.4857 4.86986 4.86791 5.48765 5.19636 6.02758C5.99624 7.34033 5.28793 9.0526 3.79418 9.41544C3.17949 9.56467 3.17949 10.4381 3.79418 10.5873C5.28793 10.9501 5.99624 12.6624 5.19636 13.9752C4.86791 14.5151 5.4857 15.1329 6.02563 14.8044C7.33838 14.0046 9.05065 14.7129 9.41349 16.2066C9.56271 16.8213 10.4361 16.8213 10.5854 16.2066C10.9482 14.7129 12.6605 14.0046 13.9732 14.8044C14.5131 15.1329 15.1309 14.5151 14.8025 13.9752C14.0026 12.6624 14.7109 10.9502 16.2047 10.5873C16.8194 10.4381 16.8194 9.56467 16.2047 9.41544C14.7109 9.0526 14.0026 7.34033 14.8025 6.02758C15.1309 5.48765 14.5131 4.86986 13.9732 5.19832C12.6605 5.99819 10.9482 5.28989 10.5854 3.79614ZM11.6661 10.0014C11.6661 9.0809 10.9199 8.33471 9.99942 8.33471C9.07895 8.33471 8.33276 9.0809 8.33276 10.0014C8.33276 10.9219 9.07895 11.668 9.99942 11.668C10.9199 11.668 11.6661 10.9219 11.6661 10.0014ZM13.3328 10.0014C13.3328 11.8423 11.8404 13.3347 9.99942 13.3347C8.15848 13.3347 6.66609 11.8423 6.66609 10.0014C6.66609 8.16043 8.15848 6.66804 9.99942 6.66804C11.8404 6.66804 13.3328 8.16043 13.3328 10.0014Z"
                    fill="currentColor"
                  />
                </svg>
                <span>{{ t('commonSettings') }}</span>
              </button>
              <mat-menu #settingsMenu="matMenu" class="settings-dropdown-menu">
                @for (item of settingsMenuItems(); track item.id) {
                  <button
                    mat-menu-item
                    [id]="'settings-menu-' + item.id"
                    class="settings-menu-item"
                    (click)="item.action()"
                  >
                    <ld-svg-icon class="w-5 h-5 shrink-0" [src]="item.icon" aria-hidden="true" />
                    <span class="font-dm text-sm font-medium text-ld-neutral">
                      {{ t(item.labelKey) }}
                    </span>
                  </button>
                }
              </mat-menu>

              <div class="h-8 w-px bg-white/30" aria-hidden="true"></div>

              <button
                id="help-resources-btn"
                type="button"
                class="flex items-center gap-2 h-full px-2 py-6 text-base font-medium tracking-[0.32px] border-b-4 transition-colors cursor-pointer bg-transparent border-x-0 border-t-0"
                [class]="
                  isActiveTab('help')
                    ? 'text-ld-lime border-ld-lime font-semibold'
                    : 'text-white border-transparent hover:text-ld-lime'
                "
                [matMenuTriggerFor]="helpResourcesMenu"
              >
                <svg
                  class="w-6 h-6 shrink-0"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <g clip-path="url(#help-clip)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 0C3.58854 0 0 3.58854 0 8C0 12.4115 3.58854 16 8 16C12.4115 16 16 12.4115 16 8C16 3.58854 12.4115 0 8 0ZM8 1.33333C11.6901 1.33333 14.6667 4.3099 14.6667 8C14.6667 11.6901 11.6901 14.6667 8 14.6667C4.3099 14.6667 1.33333 11.6901 1.33333 8C1.33333 4.3099 4.3099 1.33333 8 1.33333Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 5C7.30856 5 6.74004 5.52632 6.67323 6.20019C6.66597 6.27347 6.60697 6.33333 6.53333 6.33333H5.46667C5.39303 6.33333 5.33299 6.27357 5.33661 6.20002C5.40607 4.7892 6.57194 3.66667 8 3.66667C9.47276 3.66667 10.6667 4.86057 10.6667 6.33333C10.6667 7.54011 9.86561 8.5587 8.76624 8.8881C8.70797 8.90556 8.66667 8.95834 8.66667 9.01917V9.53333C8.66667 9.60697 8.60697 9.66667 8.53333 9.66667H7.46667C7.39303 9.66667 7.33333 9.60697 7.33333 9.53333V8.66667C7.33333 8.09188 7.7877 7.72092 8.2221 7.64836C8.85265 7.54303 9.33333 6.99366 9.33333 6.33333C9.33333 5.59695 8.73638 5 8 5Z"
                      fill="currentColor"
                    />
                    <path
                      d="M8.80003 11.5333C8.80003 11.9752 8.44186 12.3333 8.00003 12.3333C7.5582 12.3333 7.20003 11.9752 7.20003 11.5333C7.20003 11.0915 7.5582 10.7333 8.00003 10.7333C8.44186 10.7333 8.80003 11.0915 8.80003 11.5333Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="help-clip"><rect width="16" height="16" fill="white" /></clipPath>
                  </defs>
                </svg>
                <span>{{ t('commonHelp') }}</span>
              </button>
              <mat-menu #helpResourcesMenu="matMenu" id="help-resources-menu" class="help-resources-dropdown-menu">
                <button mat-menu-item id="menu-faqs" class="help-menu-item" (click)="onFaqs()">
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="faqIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('commonHelpFaqs') }}</span>
                </button>
                <button
                  mat-menu-item
                  id="menu-payoff-quote"
                  class="help-menu-item"
                  [disabled]="isPayoffQuoteDisabled()"
                  [class.opacity-50]="isPayoffQuoteDisabled()"
                  (click)="onPayoffQuote()"
                >
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="payoffQuoteIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('commonPayoffQuoteTitle') }}</span>
                </button>
                <button mat-menu-item id="menu-property-taxes" class="help-menu-item" (click)="onPropertyTaxes()">
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="propertyTaxIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('propertyTaxesTitle') }}</span>
                </button>
                <button
                  mat-menu-item
                  id="menu-homeowners-insurance"
                  class="help-menu-item"
                  (click)="onHomeownersInsurance()"
                >
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="homeownersInsuranceIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('helpMenuHomeownersInsurance') }}</span>
                </button>
                <button mat-menu-item id="menu-insurance-claims" class="help-menu-item" (click)="onInsuranceClaims()">
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="insuranceClaimsIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('insuranceClaimsTitle') }}</span>
                </button>
                <button
                  mat-menu-item
                  id="menu-financial-hardship"
                  class="help-menu-item"
                  (click)="onFinancialHardship()"
                >
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="financialHardshipIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('financialHardshipTitle') }}</span>
                </button>
                <button
                  mat-menu-item
                  id="menu-mobile-app-tutorial"
                  class="help-menu-item"
                  (click)="onMobileAppTutorial()"
                >
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="mobileAppTutorialIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('helpMenuMobileAppTutorial') }}</span>
                </button>
                <button mat-menu-item id="menu-contact-us" class="help-menu-item" (click)="onContactUs()">
                  <ld-svg-icon class="w-6 h-6 shrink-0" [src]="contactUsIcon" aria-hidden="true" />
                  <span class="font-dm text-base text-ld-neutral">{{ t('contactUsTitle') }}</span>
                </button>
              </mat-menu>

              @if (hasLoan() && !shouldHideMessages()) {
                <button
                  id="messages-btn"
                  type="button"
                  class="flex items-center gap-2 h-full px-2 py-6 text-base font-medium tracking-[0.32px] border-b-4 transition-colors cursor-pointer bg-transparent border-x-0 border-t-0"
                  [class]="
                    isActiveTab('messages')
                      ? 'text-ld-lime border-ld-lime font-semibold'
                      : 'text-white border-transparent hover:text-ld-lime'
                  "
                  (click)="onMessageCenter()"
                >
                  <svg
                    class="w-6 h-6 shrink-0"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.33333 3.33333C1.33333 2.59695 1.93029 2 2.66667 2H13.3333C14.0697 2 14.6667 2.59695 14.6667 3.33333V12.6667C14.6667 13.403 14.0697 14 13.3333 14H2.66667C1.93029 14 1.33333 13.403 1.33333 12.6667V3.33333ZM2.66667 3.33333V12.6667H13.3333V3.33333H2.66667Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.55719 3.16795C1.79766 2.92748 2.18903 2.92748 2.4295 3.16795L8 8.73845L13.5705 3.16795C13.811 2.92748 14.2023 2.92748 14.4428 3.16795C14.6833 3.40842 14.6833 3.79979 14.4428 4.04026L8.43614 10.0469C8.19567 10.2874 7.8043 10.2874 7.56383 10.0469L1.55719 4.04026C1.31672 3.79979 1.31672 3.40842 1.55719 3.16795Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>{{ t('commonMessages') }}</span>
                </button>
              }
            </nav>

            <div class="flex xl:hidden items-center ml-auto">
              <button
                id="mobile-menu-btn"
                type="button"
                class="flex items-center justify-center p-2 text-white hover:bg-white/10 rounded-lg transition-colors cursor-pointer bg-transparent border-none"
                [matMenuTriggerFor]="mobileMenu"
                [attr.aria-label]="t('commonAriaOpenNavigationMenu')"
              >
                <mat-icon class="w-6! h-6! text-[24px]!" aria-hidden="true">menu</mat-icon>
              </button>
              <mat-menu #mobileMenu="matMenu" class="mobile-nav-menu">
                <button
                  mat-menu-item
                  id="mobile-nav-payments"
                  [disabled]="!hasLoan()"
                  (click)="hasLoan() ? onPayments() : null"
                >
                  <div class="flex items-center gap-3">
                    <svg
                      class="w-6 h-6 shrink-0"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M15 7.5C15 7.03976 14.6269 6.66667 14.1667 6.66667H5.83333C5.3731 6.66667 5 7.03976 5 7.5V12.5C5 12.9602 5.3731 13.3333 5.83333 13.3333H14.1667C14.6269 13.3333 15 12.9602 15 12.5V7.5ZM10.8333 10C10.8333 9.53976 10.4602 9.16667 10 9.16667C9.53976 9.16667 9.16667 9.53976 9.16667 10C9.16667 10.4602 9.53976 10.8333 10 10.8333C10.4602 10.8333 10.8333 10.4602 10.8333 10ZM12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10ZM11.6667 4.16667C11.6667 3.70643 11.2936 3.33333 10.8333 3.33333H2.5C2.03976 3.33333 1.66667 3.70643 1.66667 4.16667V9.16667C1.66667 9.6269 2.03976 10 2.5 10H3.33333V7.5C3.33333 6.11929 4.45262 5 5.83333 5H11.6667V4.16667ZM13.3333 5H14.1667C15.5474 5 16.6667 6.11929 16.6667 7.5V12.5C16.6667 13.8807 15.5474 15 14.1667 15H5.83333C4.45262 15 3.33333 13.8807 3.33333 12.5V11.6667H2.5C1.11929 11.6667 0 10.5474 0 9.16667V4.16667C0 2.78595 1.11929 1.66667 2.5 1.66667H10.8333C12.214 1.66667 13.3333 2.78595 13.3333 4.16667V5Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span>{{ t('commonPayments') }}</span>
                  </div>
                </button>

                <button
                  mat-menu-item
                  id="mobile-nav-statements"
                  [disabled]="!hasLoan()"
                  (click)="hasLoan() ? onStatementsDocuments() : null"
                >
                  <div class="flex items-center gap-3">
                    <svg
                      class="w-6 h-6 shrink-0"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M3.33398 15.8346V4.16797C3.33398 2.78726 4.45327 1.66797 5.83398 1.66797H10.4889C10.9309 1.668 11.3548 1.84372 11.6673 2.15625L16.179 6.66797C16.4916 6.9805 16.6673 7.40437 16.6673 7.84635V15.8346C16.6673 17.2153 15.548 18.3346 14.1673 18.3346H5.83398C4.45327 18.3346 3.33398 17.2153 3.33398 15.8346ZM12.5007 12.5013C12.9609 12.5013 13.334 12.8744 13.334 13.3346C13.334 13.7949 12.9609 14.168 12.5007 14.168H7.50065C7.04041 14.168 6.66732 13.7949 6.66732 13.3346C6.66732 12.8744 7.04041 12.5013 7.50065 12.5013H12.5007ZM12.5007 9.16797C12.9609 9.16797 13.334 9.54106 13.334 10.0013C13.334 10.4615 12.9609 10.8346 12.5007 10.8346H7.50065C7.04041 10.8346 6.66732 10.4615 6.66732 10.0013C6.66732 9.54106 7.04041 9.16797 7.50065 9.16797H12.5007ZM5.00065 15.8346C5.00065 16.2949 5.37375 16.668 5.83398 16.668H14.1673C14.6276 16.668 15.0007 16.2949 15.0007 15.8346V7.84635L10.4889 3.33464H5.83398C5.37375 3.33464 5.00065 3.70773 5.00065 4.16797V15.8346Z"
                        fill="currentColor"
                      />
                    </svg>
                    <span>{{ t('commonStatementsDocuments') }}</span>
                  </div>
                </button>

                <div class="mobile-menu-section-header">
                  <span>{{ t('commonSettings') }}</span>
                </div>
                @for (item of settingsMenuItems(); track item.id) {
                  <button mat-menu-item [id]="'mobile-settings-' + item.id" (click)="item.action()">
                    <div class="flex items-center gap-3">
                      <ld-svg-icon class="w-5 h-5 shrink-0" [src]="item.icon" aria-hidden="true" />
                      <span>{{ t(item.labelKey) }}</span>
                    </div>
                  </button>
                }

                <div class="mobile-menu-section-header">
                  <span>{{ t('commonHelpResources') }}</span>
                </div>
                <button mat-menu-item id="mobile-nav-faqs" (click)="onFaqs()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="faqIcon" aria-hidden="true" />
                    <span>{{ t('commonHelpFaqs') }}</span>
                  </div>
                </button>
                <button
                  mat-menu-item
                  id="mobile-nav-payoff-quote"
                  [disabled]="isPayoffQuoteDisabled()"
                  [class.opacity-50]="isPayoffQuoteDisabled()"
                  (click)="onPayoffQuote()"
                >
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="payoffQuoteIcon" aria-hidden="true" />
                    <span>{{ t('commonPayoffQuoteTitle') }}</span>
                  </div>
                </button>
                <button mat-menu-item id="mobile-nav-property-taxes" (click)="onPropertyTaxes()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="propertyTaxIcon" aria-hidden="true" />
                    <span>{{ t('propertyTaxesTitle') }}</span>
                  </div>
                </button>
                <button mat-menu-item id="mobile-nav-homeowners-insurance" (click)="onHomeownersInsurance()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="homeownersInsuranceIcon" aria-hidden="true" />
                    <span>{{ t('helpMenuHomeownersInsurance') }}</span>
                  </div>
                </button>
                <button mat-menu-item id="mobile-nav-insurance-claims" (click)="onInsuranceClaims()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="insuranceClaimsIcon" aria-hidden="true" />
                    <span>{{ t('insuranceClaimsTitle') }}</span>
                  </div>
                </button>
                <button mat-menu-item id="mobile-nav-financial-hardship" (click)="onFinancialHardship()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="financialHardshipIcon" aria-hidden="true" />
                    <span>{{ t('financialHardshipTitle') }}</span>
                  </div>
                </button>
                <button mat-menu-item id="mobile-nav-mobile-app-tutorial" (click)="onMobileAppTutorial()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="mobileAppTutorialIcon" aria-hidden="true" />
                    <span>{{ t('helpMenuMobileAppTutorial') }}</span>
                  </div>
                </button>
                <button mat-menu-item id="mobile-nav-contact-us" (click)="onContactUs()">
                  <div class="flex items-center gap-3">
                    <ld-svg-icon class="w-6 h-6 shrink-0" [src]="contactUsIcon" aria-hidden="true" />
                    <span>{{ t('contactUsTitle') }}</span>
                  </div>
                </button>

                @if (hasLoan() && !shouldHideMessages()) {
                  <button mat-menu-item id="mobile-nav-messages" (click)="onMessageCenter()">
                    <div class="flex items-center gap-3">
                      <svg
                        class="w-6 h-6 shrink-0"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.33333 3.33333C1.33333 2.59695 1.93029 2 2.66667 2H13.3333C14.0697 2 14.6667 2.59695 14.6667 3.33333V12.6667C14.6667 13.403 14.0697 14 13.3333 14H2.66667C1.93029 14 1.33333 13.403 1.33333 12.6667V3.33333ZM2.66667 3.33333V12.6667H13.3333V3.33333H2.66667Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.55719 3.16795C1.79766 2.92748 2.18903 2.92748 2.4295 3.16795L8 8.73845L13.5705 3.16795C13.811 2.92748 14.2023 2.92748 14.4428 3.16795C14.6833 3.40842 14.6833 3.79979 14.4428 4.04026L8.43614 10.0469C8.19567 10.2874 7.8043 10.2874 7.56383 10.0469L1.55719 4.04026C1.31672 3.79979 1.31672 3.40842 1.55719 3.16795Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>{{ t('commonMessages') }}</span>
                    </div>
                  </button>
                }
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
    }
  }
</ng-container>

<ld-error-modal
  id="payoff-quote-contact-us-modal"
  [isOpen]="showPayoffContactUsModal()"
  title="Please Contact Us"
  [message]="payoffContactUsMessage()"
  icon="warning"
  iconPosition="header"
  [headerIconSrc]="payoffContactUsIconSrc"
  primaryBtnText="CLOSE"
  (closed)="onClosePayoffContactUsModal()"
  (primaryClick)="onClosePayoffContactUsModal()"
/>
